export default __webpack_public_path__ + "static/media/upload.2a3d032d.svg";